import React from "react";
import { BsCheckLg, BsXLg } from "react-icons/bs";
import "./status-icon.css";

const iconByStatus = {
	success: BsCheckLg,
	danger: BsXLg,
	error: BsXLg
};

const StatusIcon = ({
	status = "success",
	label,
	size = 28,
	iconSize = 14,
	className = ""
}) => {
	const Icon = iconByStatus[status];

	if (!Icon) {
		return <span className="status-icon__empty">—</span>;
	}

	return (
		<span
			className={[
				"status-icon",
				`status-icon--${status}`,
				className
			].filter(Boolean).join(" ")}
			style={{
				width: size,
				height: size
			}}
			aria-label={label}
			title={label}
		>
			<Icon size={iconSize} />
		</span>
	);
};

export default StatusIcon;